import React from "react"
import { useTranslation } from "react-i18next"

import { Content } from "pages/dashboard/elements"
import Title from "components/ui/Title"

const MessagesPage = () => {
  const { t } = useTranslation()

  return (
    <Content data-testid="messages-page">
      <Title>{t("pages.messages.title")}</Title>
    </Content>
  )
}

export default MessagesPage
